var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "calendar-settings-overlay" }, [
    _c(
      "div",
      { staticClass: "overlay-content" },
      [
        _c("h3", [_vm._v(_vm._s(_vm.$t("tables.calendarSettings")))]),
        _vm._v(" "),
        _c("label", [_vm._v(_vm._s(_vm.$t("tables.colorBy")) + ":")]),
        _vm._v(" "),
        _c("CustomPicker", {
          attrs: {
            items: _vm.dropdownFields,
            idKey: "_id",
            labelKey: "name",
            title: _vm.$t("tables.selectColorField"),
            icon: "palette",
          },
          model: {
            value: _vm.localSettings.colorByField,
            callback: function ($$v) {
              _vm.$set(_vm.localSettings, "colorByField", $$v)
            },
            expression: "localSettings.colorByField",
          },
        }),
        _vm._v(" "),
        _c("label", [_vm._v(_vm._s(_vm.$t("tables.startDateField")) + ":")]),
        _vm._v(" "),
        _c("CustomPicker", {
          attrs: {
            items: _vm.dateFields,
            idKey: "_id",
            labelKey: "name",
            title: _vm.$t("tables.selectStartDateField"),
            icon: "event",
          },
          model: {
            value: _vm.localSettings.calendarFieldStart,
            callback: function ($$v) {
              _vm.$set(_vm.localSettings, "calendarFieldStart", $$v)
            },
            expression: "localSettings.calendarFieldStart",
          },
        }),
        _vm._v(" "),
        _c("label", [_vm._v(_vm._s(_vm.$t("tables.endDateField")) + ":")]),
        _vm._v(" "),
        _c("CustomPicker", {
          attrs: {
            items: [{ _id: "", name: "(None)" }].concat(_vm.dateFields),
            idKey: "_id",
            labelKey: "name",
            title: _vm.$t("tables.selectEndDateField"),
            icon: "event",
          },
          model: {
            value: _vm.localSettings.calendarFieldEnd,
            callback: function ($$v) {
              _vm.$set(_vm.localSettings, "calendarFieldEnd", $$v)
            },
            expression: "localSettings.calendarFieldEnd",
          },
        }),
        _vm._v(" "),
        _c("h4", [_vm._v(_vm._s(_vm.$t("tables.eventCardFields")))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "calendar-card-fields" },
          _vm._l(_vm.fields, function (field) {
            return _c(
              "div",
              { key: field._id, staticClass: "field-row" },
              [
                _c("a-switch", {
                  attrs: {
                    checked:
                      _vm.localSettings.cardFields.indexOf(field._id) !== -1,
                  },
                  on: {
                    change: function (checked) {
                      return _vm.toggleCardField(field._id, checked)
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(field.name))]),
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { ghost: "" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("tables.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.handleSave } },
              [_vm._v(_vm._s(_vm.$t("tables.save")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }